export default {
  plural_label: "Agences",
  single_label: "agence",
  auth_feature: 'agency',
  use_new_modal: false,
  use_edit_modal: false,


  store_namespace: 'agency',
  new_route_name: "AdminAgencyNew",
  edit_route_name: "AdminAgencyEdit",
  detail_route_name: "AdminAgencyDetail",
  csv_export_filename_prefix: 'agency',
  hide_action_new_button: true,
  hide_action_pdf_button: true,
  hide_action_edit_button: false,
  hide_action_delete_button: true,
  submit_formatter: item => ({
    ...item,
    address : {
      street : item.street,
      zip_code : item.zip_code,
      city : item.city,
    },
    // entity: {
    //   id: item.entity_id,
    // },
  }),
  export_csv: true,
  export_pdf: true,
  duplications: true,
  title_field: 'code',
  sort_by: 'code',
  sort_desc: false,
  fields: [
    {
      name: 'code',
      label: "Code",
      type: 'text',
      inForm: true,
      required: true,
      inList: true,
      filterIn: true,
      inDetail: true,
      inCsvExport: true,
      inPdfExport: true,
      sortable: true,
      disabled: true
    },
    {
      name: 'name',
      label: "Nom",
      type: 'text',
      inForm: true,
      required: true,
      inList: true,
      filterIn: true,
      inDetail: true,
      sortable: true,
      inCsvExport: true,
      inPdfExport: true,
    },
    {
      name: "address",
      label: "Adresse",
      type: "text",
      inForm: false,
      required: true,
      inList: true,
      filterIn: true,
      inDetail: true,
      inCsvExport: true,
      inPdfExport: true,
      formatter: (context, value) => value ? value.street + ' ' + value.zip_code + ' ' + value.city : null
    },
    {
      name: 'street',
      label: "Rue",
      type: 'text',
      inForm: true,
      required: true,
      inList: false,
      filterIn: false,
      inDetail: false,
      sortable: false,
      inCsvExport: false,
      inPdfExport: false,
    },
    {
      name: 'zip_code',
      label: "Code postal",
      type: 'text',
      inForm: true,
      required: true,
      inList: false,
      filterIn: false,
      inDetail: false,
      sortable: false,
      inCsvExport: false,
      inPdfExport: false,
    },
    {
      name: 'city',
      label: "Ville",
      type: 'text',
      inForm: true,
      required: false,
      inList: false,
      filterIn: false,
      inDetail: false,
      sortable: false,
      inCsvExport: false,
      inPdfExport: false,
    },
  ]
}



// WEBPACK FOOTER //
// ./src/components/Agency/config.js